
















  import { Component, Prop, Vue } from 'vue-property-decorator';

  @Component
  export default class StarRating extends Vue {

    @Prop() private rating!: number;

    // computed
    get normalizedRating(): number {
      if ( this.rating < 0 ) {
        return 0;
      }
      if ( this.rating > 10 ) {
        return 10;
      }
      return this.rating;
    }

    get starIconList(): string[] {
      const list = [];
      let total = this.normalizedRating;
      for (let i = 0; i < 5; i++) {
        if ( total >= 2 ) {
          list.push('mdi-star');
        }
        else if ( total >= 1 ) {
          list.push('mdi-star-half');
        }
        else {
          list.push('mdi-star-outline');
        }
        total -= 2;
      }
      return list;
    }

}

